var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 5,
    viewBox: "0 0 22 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2.75C4.5 1.50736 3.49264 0.5 2.25 0.5C1.00736 0.5 -1.52668e-07 1.50736 -9.83506e-08 2.75C-4.40331e-08 3.99264 1.00736 5 2.25 5C3.49264 5 4.5 3.99264 4.5 2.75Z",
    fill: "#6E7191"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0937 2.75C13.0937 1.50736 12.0864 0.5 10.8437 0.5C9.60111 0.5 8.59375 1.50736 8.59375 2.75C8.59375 3.99264 9.60111 5 10.8438 5C12.0864 5 13.0937 3.99264 13.0937 2.75Z",
    fill: "#6E7191"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6797 2.75C21.6797 1.50736 20.6723 0.5 19.4297 0.5C18.187 0.5 17.1797 1.50736 17.1797 2.75C17.1797 3.99264 18.187 5 19.4297 5C20.6723 5 21.6797 3.99264 21.6797 2.75Z",
    fill: "#6E7191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.0f573767a7a068786e7bb960fa90c51b.svg";
export { ForwardRef as ReactComponent };